<template>
  <section class="team">
    <div class="heading">
      <div class="heading-container">
        <h3>our team</h3>
        <p>
          <router-link :to="{ name: 'Home' }" class="home text-decoration-none"
            >home</router-link
          >
          / <span>team</span>
        </p>
      </div>
    </div>
    <div class="team-container">
      <h1 class="title">
        <span>our team</span>
        <a class="text-decoration-none" href=""> view all >></a>
      </h1>
      <div class="box-container">
        <div v-for="team in teams" :key="team.id" class="box">
          <div class="share">
            <router-link to="" class="facebook text-decoration-none"
              ><font-awesome-icon
                :icon="{ prefix: 'fab', iconName: 'facebook-f' }"
              />
            </router-link>
            <router-link to="" class="twitter text-decoration-none"
              ><font-awesome-icon
                :icon="{ prefix: 'fab', iconName: 'twitter' }"
              />
            </router-link>
            <router-link to="" class="pinterest text-decoration-none"
              ><font-awesome-icon
                :icon="{ prefix: 'fab', iconName: 'pinterest' }"
              />
            </router-link>
            <router-link to="" class="instagram text-decoration-none"
              ><font-awesome-icon
                :icon="{ prefix: 'fab', iconName: 'instagram' }"
              />
            </router-link>
          </div>
          <div class="image">
            <img :src="team.image" alt="" />
          </div>
          <div class="user">
            <h3>{{ team.name }}</h3>
            <span>designer</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const dummyData = {
  teams: [
    {
      id: "1",
      name: "john deo",
      image: require("@/images/team-1.jpg"),
    },
    {
      id: "2",
      name: "john deo",
      image: require("@/images/team-2.jpg"),
    },
    {
      id: "3",
      name: "john deo",
      image: require("@/images/team-3.jpg"),
    },
    {
      id: "4",
      name: "john deo",
      image: require("@/images/team-4.jpg"),
    },
    {
      id: "5",
      name: "john deo",
      image: require("@/images/team-5.jpg"),
    },
    {
      id: "6",
      name: "john deo",
      image: require("@/images/team-6.jpg"),
    },
  ],
};

export default {
  data() {
    return {
      teams: [],
    };
  },
  created() {
    this.fetchTeams();
  },
  methods: {
    fetchTeams() {
      this.teams = dummyData.teams;
    },
  },
};
</script>